// AddCustomer.tsx
import React, { useState } from "react";
import { Modal, TextInput, Button } from "@mantine/core";
import { RowDataMember } from "./types"; // Make sure to import the RowData type from your Member.tsx file
import classes from "../MemberPage/Member.module.css";
interface AddCustomerProps {
  isVisible: boolean;
  onClose: () => void;
  onAddCustomer: (
    newCustomer: RowDataMember,
    onSuccess: () => void,
    onFailure: () => void
  ) => void;
}

const AddCustomer: React.FC<AddCustomerProps> = ({
  isVisible,
  onClose,
  onAddCustomer,
}) => {
  const [newCustomer, setNewCustomer] = useState<RowDataMember>({
    name: "",
    email: "",
    nric: "",
    nric_fullname: "",
    contactNo: "",
    profilePicture: "",
    expoPushToken: "",
    referral: "",
    tempCode: "",
    tempCodeTime: "",
    membershipType: "",
    isDealer: "",
    company: "",
    coins: "",
    cash: "",
    daily: "",
    action: "",
    uid: "",
    dob: "",
    isVerified: null,
    isFastPass: null,
    createdAt: "",
    isCorporate: false,
    deleted: false,
  });

  const handleAddCustomer = () => {
    // Check if any field is empty
    if (
      !newCustomer.name ||
      !newCustomer.nric ||
      !newCustomer.nric_fullname ||
      !newCustomer.contactNo ||
      !newCustomer.profilePicture ||
      !newCustomer.expoPushToken ||
      !newCustomer.referral ||
      !newCustomer.tempCode ||
      !newCustomer.tempCodeTime ||
      !newCustomer.membershipType ||
      !newCustomer.isDealer ||
      !newCustomer.company ||
      !newCustomer.coins ||
      !newCustomer.cash ||
      !newCustomer.daily ||
      !newCustomer.action ||
      !newCustomer.uid
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all fields.");
      return;
    }

    // Validation passed, proceed with adding the customer
    onAddCustomer(
      {
        ...newCustomer,
        action: "Edit", // Adding the missing 'action' property
      },
      () => {
        // Success callback
        setNewCustomer({
          name: "",
          email: "",
          nric: "",
          nric_fullname: "",
          contactNo: "",
          profilePicture: "",
          expoPushToken: "",
          referral: "",
          tempCode: "",
          tempCodeTime: "",
          membershipType: "",
          isDealer: "",
          company: "",
          coins: "",
          cash: "",
          daily: "",
          action: "",
          uid: "",
          dob: "",
          isVerified: null,
          isFastPass: null,
          createdAt: "",
          isCorporate: false,
          deleted: false,
        });
        onClose();
      },
      () => {
        // Failure callback
        // You can handle the failure scenario here (e.g., show an error message)
      }
    );
  };

  return (
    <Modal
      opened={isVisible}
      title="Add Customer"
      onClose={onClose}
      size="md"
      padding="lg"
    >
      <div className={classes.addCustomerForm}>
        {/* Display fields for adding */}
        <TextInput
          label="Name"
          maxLength={255}
          value={newCustomer.name}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              name: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Email"
          maxLength={255}
          value={newCustomer.email}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              email: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="IC No."
          maxLength={999}
          value={newCustomer.nric}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              nric: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="IC No."
          maxLength={999}
          value={newCustomer.nric_fullname}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              nric_fullname: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Contact No."
          maxLength={999}
          value={newCustomer.contactNo}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              contactNo: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Profile Picture  "
          value={newCustomer.profilePicture}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              profilePicture: e.currentTarget.value,
            })
          }
        />

        <TextInput
          label="expoPushToken"
          value={newCustomer.expoPushToken}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              expoPushToken: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="referral"
          value={newCustomer.referral}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              referral: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Temp Code"
          value={newCustomer.tempCode}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              tempCode: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Temp Code Time"
          value={newCustomer.tempCodeTime}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              tempCodeTime: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Membership Type"
          value={newCustomer.membershipType}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              membershipType: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Dealer"
          value={newCustomer.isDealer}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              isDealer: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Company"
          value={newCustomer.company}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              company: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Coins"
          value={newCustomer.coins}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              coins: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Cash"
          value={newCustomer.cash}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              cash: e.currentTarget.value,
            })
          }
        />
        <TextInput
          label="Daily"
          value={newCustomer.daily}
          onChange={(e) =>
            setNewCustomer({
              ...newCustomer,
              daily: e.currentTarget.value,
            })
          }
        />
        <Button onClick={handleAddCustomer} className={classes.modaladdbutton}>
          Add Customer
        </Button>
      </div>
    </Modal>
  );
};

export default AddCustomer;
